"use client";

import React, { useState, useMemo, useCallback } from "react";
import { COUNTRIES } from "./constants";
import { generateCountryDots, generateStateDots } from "./utils";
import WorldMapBase from "./WorldMapBase";
import CountryInfoCard from "./CountryInfoCard";
import MapLegend from "./MapLegend";

export default function InteractiveWorldMap() {
  const [focusedCountry, setFocusedCountry] = useState(null);
  const [zoom, setZoom] = useState(1);
  const [center, setCenter] = useState([15, 15]);

  const countryDotClouds = useMemo(
    () =>
      COUNTRIES.map((c, i) => ({
        countryCode: c.countryCode,
        dots: generateCountryDots(c.center, c.count, (i + 1) * 137),
      })),
    []
  );

  const stateDotClouds = useMemo(
    () =>
      COUNTRIES.map((country, ci) => ({
        countryCode: country.countryCode,
        states: country.states.map((state, si) => {
          const stateCenter = [
            country.center[0] + state.offset[0],
            country.center[1] + state.offset[1],
          ];
          return {
            name: state.name,
            center: stateCenter,
            dots: generateStateDots(
              stateCenter,
              state.count,
              state.spread ?? [0.8, 0.7],
              (ci + 1) * 137 + (si + 1) * 53
            ),
          };
        }),
      })),
    []
  );

  const handleCountryHover = useCallback((c) => {
    setFocusedCountry(c);
    setCenter(c.zoomCenter);
    setZoom(c.zoomLevel);
  }, []);

  const handleMapLeave = useCallback(() => {
    setFocusedCountry(null);
    setCenter([15, 15]);
    setZoom(1);
  }, []);

  return (
    <div className="relative w-full">
      <div
        className="relative w-full rounded-2xl overflow-hidden bg-[#0F1020] border border-white/5"
        onMouseLeave={handleMapLeave}
      >
        <WorldMapBase
          zoom={zoom}
          center={center}
          focusedCountry={focusedCountry}
          countries={COUNTRIES}
          countryDotClouds={countryDotClouds}
          stateDotClouds={stateDotClouds}
          onCountryHover={handleCountryHover}
        />

        <CountryInfoCard focusedCountry={focusedCountry} />
        <MapLegend focusedCountry={focusedCountry} />
      </div>
    </div>
  );
}
